<nav class="navbar-default navbar-static-side" role="navigation">
  <div class="sidebar-collapse">
    <ul [hidden]="!isAuthenticated()" class="nav metismenu" id="side-menu">
      <li class="nav-header">
        <div class="dropdown profile-element">
          <span> </span>
          <a data-toggle="dropdown" class="dropdown-toggle" href="#">
            <span class="clear">
              <span class="block m-t-xs">
                <strong class="font-bold">{{ userName() }}</strong>
              </span>
              <span class="text-muted text-xs block">{{ userRole() }} </span>
            </span>
          </a>
        </div>
        <div class="logo-element"></div>
      </li>
      @for (item of items(); track item) {
        <li
          [class.active]="false"
          routerLinkActive="active"
          >
          <!-- Navigation item with children (expandable) -->
          @if (item.children && item.children.length > 0) {
            <a
              href="javascript:void(0)"
              (click)="onExpandableItemClick($event, item)"
              [class.nav-disabled]="!canExpand(item)"
              >
              <i [class]="item.icon || 'fa fa-th-large'"></i>
              <span class="nav-label">{{ item.name }}</span>
              @if (canExpand(item)) {
                <span class="fa arrow"></span>
              }
            </a>
          }
          <!-- Navigation item without children (direct link) -->
          @if (!item.children || item.children.length === 0) {
            <a
              [routerLink]="item.readonly ? undefined : item.url"
              [class.nav-disabled]="item.readonly"
              (click)="item.readonly && $event.preventDefault()"
              [attr.href]="item.readonly ? 'javascript:void(0)' : null"
              >
              <i [class]="item.icon || 'fa fa-th-large'"></i>
              <span class="nav-label">{{ item.name }}</span>
            </a>
          }
          @if (item.children) {
            <ul class="nav nav-second-level collapse">
              @for (child of item.children; track child) {
                <li
                  [class.active]="false"
                  routerLinkActive="active"
                  >
                  <!-- Second level with children (expandable) -->
                  @if (child.children && child.children.length > 0) {
                    <a
                      href="javascript:void(0)"
                      (click)="onExpandableItemClick($event, child)"
                      [class.nav-disabled]="!canExpand(child)"
                      >
                      <i [class]="child.icon || 'fa fa-th-large'"></i>
                      {{ child.name }}
                      @if (canExpand(child)) {
                        <span class="fa arrow"></span>
                      }
                    </a>
                  }
                  <!-- Second level without children (direct link) -->
                  @if (!child.children || child.children.length === 0) {
                    <a
                      [routerLink]="child.readonly ? undefined : child.url"
                      [class.nav-disabled]="child.readonly"
                      (click)="child.readonly && $event.preventDefault()"
                      [attr.href]="child.readonly ? 'javascript:void(0)' : null"
                      >
                      <i [class]="child.icon || 'fa fa-th-large'"></i>
                      {{ child.name }}
                    </a>
                  }
                  @if (child.children) {
                    <ul class="nav nav-third-level collapse">
                      @for (grandchild of child.children; track grandchild) {
                        <li
                          routerLinkActive="active"
                          >
                          <a
                  [routerLink]="
                    grandchild.readonly ? undefined : grandchild.url
                  "
                            [class.nav-disabled]="grandchild.readonly"
                            (click)="grandchild.readonly && $event.preventDefault()"
                  [attr.href]="
                    grandchild.readonly ? 'javascript:void(0)' : null
                  "
                            >
                            <i [class]="grandchild.icon || 'fa fa-th-large'"></i>
                            {{ grandchild.name }}
                          </a>
                        </li>
                      }
                    </ul>
                  }
                </li>
              }
            </ul>
          }
        </li>
      }
    </ul>
  </div>
</nav>
